import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { Source } from 'react-map-gl';
import { Layer, LayerBand, LAYER_ORDER } from './ordered-layer';
import { createMapSourceAtom } from './atoms';
import { MapUserConfigAtom } from './types';

const PipelineLayer = ({
  mapConfigAtom,
}: {
  mapConfigAtom: MapUserConfigAtom;
}) => {
  const pipelinesSourceAtom = useMemo(
    () => createMapSourceAtom('pipelines'),
    []
  );
  const pipelinesSource = useAtomValue(pipelinesSourceAtom);
  const mapConfig = useAtomValue(mapConfigAtom);

  if (!pipelinesSource) {
    return null;
  }

  return (
    <LayerBand band={LAYER_ORDER.pipelines}>
      <Source id="pipelines" type="vector" url={pipelinesSource}>
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.gasOperating && (
            <Layer
              id="pipelines-gas-operating"
              type="line"
              source-layer="gas-operating"
              paint={{
                'line-pattern': 'gas-operating',
                'line-width': 4,
                'line-opacity': 0.8,
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.gasUnderConstruction && (
            <Layer
              id="pipelines-gas-under-construction"
              type="line"
              source-layer="gas-construction"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-dasharray': [5, 5],
                'line-pattern': 'gas-construction',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.gasPlannedOther && (
            <Layer
              id="pipelines-gas-planned-other"
              type="line"
              source-layer="gas-planned"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-dasharray': [2, 2, 2, 2],
                'line-pattern': 'gas-planned',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.oilOperating && (
            <Layer
              id="pipelines-oil-operating"
              type="line"
              source-layer="oil-operating"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-pattern': 'oil-operating',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.oilUnderConstruction && (
            <Layer
              id="pipelines-oil-under-construction"
              type="line"
              source-layer="oil-construction"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-dasharray': [5, 5],
                'line-pattern': 'oil-construction',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.oilPlannedOther && (
            <Layer
              id="pipelines-oil-plannedOther"
              type="line"
              source-layer="oil-planned"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-dasharray': [2, 2, 2, 2],
                'line-pattern': 'oil-planned',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.productOperating && (
            <Layer
              id="pipelines-product-operating"
              type="line"
              source-layer="product-operating"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-pattern': 'product-operating',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.productConstruction && (
            <Layer
              id="pipelines-product-construction"
              type="line"
              source-layer="product-construction"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-dasharray': [5, 5],
                'line-pattern': 'product-construction',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.productPlannedOther && (
            <Layer
              id="pipelines-product-planned-other"
              type="line"
              source-layer="product-planned"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-dasharray': [2, 2, 2, 2],
                'line-pattern': 'product-planned',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.unknownOperating && (
            <Layer
              id="pipelines-unknown-operating"
              type="line"
              source-layer="unknown-operating"
              paint={{
                'line-pattern': 'unknown-operating',
                'line-width': 4,
                'line-opacity': 0.8,
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.unknownUnderConstruction && (
            <Layer
              id="pipelines-unknown-under-construction"
              type="line"
              source-layer="unknown-construction"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-dasharray': [5, 5],
                'line-pattern': 'unknown-construction',
              }}
            />
          )}
        {mapConfig?.pipelines?.checked &&
          mapConfig?.pipelines?.options?.unknownPlannedOther && (
            <Layer
              id="pipelines-unknown-planned-other"
              type="line"
              source-layer="unknown-planned"
              paint={{
                'line-width': 4,
                'line-opacity': 0.8,
                'line-dasharray': [2, 2, 2, 2],
                'line-pattern': 'unknown-planned',
              }}
            />
          )}
      </Source>
    </LayerBand>
  );
};

export { PipelineLayer };
